import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3436fdfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-card-header" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center caution-box"
}
const _hoisted_3 = { class: "ml-2" }
const _hoisted_4 = { class: "caution-text text-size-18" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "caution-text" }, "感染者への直接介助を伴う可能性があります", -1))
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between mt-1" }
const _hoisted_7 = {
  key: 1,
  class: "d-flex justify-content-end mt-1"
}
const _hoisted_8 = {
  key: 2,
  class: "mt-2 mx-n3"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 3,
  class: "order-card-images mt-2"
}
const _hoisted_13 = {
  key: 0,
  class: "order-card-images__item"
}
const _hoisted_14 = {
  key: 1,
  class: "order-card-images__item"
}
const _hoisted_15 = {
  key: 2,
  class: "order-card-images__item"
}
const _hoisted_16 = { class: "office-info" }
const _hoisted_17 = { class: "office-name-content" }
const _hoisted_18 = { class: "office-name mr-2" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "office-address" }
const _hoisted_21 = { class: "office-actions" }
const _hoisted_22 = {
  class: "work-time mt-2",
  ref: "workTime"
}
const _hoisted_23 = {
  key: 0,
  class: "application"
}
const _hoisted_24 = { class: "pl-4 work-time-detail" }
const _hoisted_25 = { class: "work-time" }
const _hoisted_26 = { class: "rest-time" }
const _hoisted_27 = { class: "salary-per-day-wrapper" }
const _hoisted_28 = { class: "salary-per-day-with-various-allowances" }
const _hoisted_29 = {
  key: 1,
  class: "d-flex flex-column align-items-start justify-content-between work-time-options"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "d-flex align-items-center" }
const _hoisted_32 = { class: "work-time" }
const _hoisted_33 = { class: "rest-time" }
const _hoisted_34 = { class: "salary-per-day-wrapper" }
const _hoisted_35 = { class: "salary-per-day-with-various-allowances" }
const _hoisted_36 = { class: "reward-detail" }
const _hoisted_37 = { class: "ml-auto hourly-wage" }
const _hoisted_38 = { class: "ml-auto various-allowances" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrderLabel = _resolveComponent("OrderLabel")!
  const _component_WatchLaterButton = _resolveComponent("WatchLaterButton")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_BeginnerOrderLabel = _resolveComponent("BeginnerOrderLabel")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_TooltipHighlightText = _resolveComponent("TooltipHighlightText")!
  const _component_TooltipPopup = _resolveComponent("TooltipPopup")!
  const _component_BCarouselSlide = _resolveComponent("BCarouselSlide")!
  const _component_BCarousel = _resolveComponent("BCarousel")!
  const _component_BImgLazy = _resolveComponent("BImgLazy")!
  const _component_EvaluationWithCount = _resolveComponent("EvaluationWithCount")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_OfficeMuteButton = _resolveComponent("OfficeMuteButton")!
  const _component_RemainingDateTime = _resolveComponent("RemainingDateTime")!
  const _component_AppRadio = _resolveComponent("AppRadio")!

  return (_openBlock(), _createElementBlock("div", {
    class: "order-card",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('card-click', _ctx.order.id)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_OrderLabel, {
        order: _ctx.order,
        orderService: _ctx.orderService
      }, null, 8, ["order", "orderService"]),
      _createTextVNode(),
      (_ctx.isWatchLaterButtonVisible)
        ? (_openBlock(), _createBlock(_component_WatchLaterButton, {
            key: 0,
            id: "tooltippopup-to-watch-later-button",
            class: "ml-auto",
            isShowButtonText: "",
            isRegisteredWatchLater: _ctx.isRegisteredWatchLater,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change-watch-later', $event)))
          }, null, 8, ["isRegisteredWatchLater"]))
        : _createCommentVNode("", true)
    ]),
    _createTextVNode(),
    (_ctx.willBeOutbreakingInfection)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_FeatherIcon, {
            icon: "alert-triangle",
            size: "20"
          }),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.infectionName) + "が発生しています\n        ", 1),
            _createTextVNode(),
            _hoisted_5
          ])
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_BeginnerOrderLabel, {
      order: _ctx.order,
      orderService: _ctx.orderService
    }, null, 8, ["order", "orderService"]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        class: _normalizeClass(["order-card-title--break", { 'order-card-title--ellipsis': _ctx.isTitleEllipsis }])
      }, _toDisplayString(_ctx.orderTitle), 3)
    ]),
    _createTextVNode(),
    (_ctx.isAbTest2807TestGroup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_Tag, {
            label: _ctx.applicantsCountLabel,
            class: _normalizeClass([_ctx.abTest2807Class, "applicants-count-tag"])
          }, null, 8, ["label", "class"])
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_TooltipPopup, {
      position: "bottom",
      targetSelector: "#tooltippopup-to-watch-later-button"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createTextVNode("\n        あとで見返したいお仕事は"),
          _createVNode(_component_TooltipHighlightText, null, {
            default: _withCtx(() => [
              _createTextVNode("あとで見る")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode("！\n      ")
        ])
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (_ctx.isCarousel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_BCarousel, {
            id: 'carousel' + _ctx.order.id,
            indicators: "",
            controls: "",
            class: "order-card-carousel"
          }, {
            default: _withCtx(() => [
              (_ctx.getOptimizedOrderImage(_ctx.order.image1))
                ? (_openBlock(), _createBlock(_component_BCarouselSlide, { key: 0 }, {
                    img: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.getOptimizedOrderImage(_ctx.order.image1),
                        class: "carousel-image"
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(),
              (_ctx.getOptimizedOrderImage(_ctx.order.image2))
                ? (_openBlock(), _createBlock(_component_BCarouselSlide, { key: 1 }, {
                    img: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.getOptimizedOrderImage(_ctx.order.image2),
                        class: "carousel-image"
                      }, null, 8, _hoisted_10)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(),
              (_ctx.getOptimizedOrderImage(_ctx.order.image3))
                ? (_openBlock(), _createBlock(_component_BCarouselSlide, { key: 2 }, {
                    img: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _ctx.getOptimizedOrderImage(_ctx.order.image3),
                        class: "carousel-image"
                      }, null, 8, _hoisted_11)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], undefined, true),
            _: 1
          }, 8, ["id"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.getOptimizedOrderImageSmall(_ctx.order.image1))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_BImgLazy, {
                  src: _ctx.getOptimizedOrderImageSmall(_ctx.order.image1),
                  alt: "",
                  class: "order-card-images__item-img"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (_ctx.getOptimizedOrderImageSmall(_ctx.order.image2))
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_BImgLazy, {
                  src: _ctx.getOptimizedOrderImage(_ctx.order.image2),
                  alt: "",
                  class: "order-card-images__item-img"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createTextVNode(),
          (_ctx.getOptimizedOrderImage(_ctx.order.image3))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_BImgLazy, {
                  src: _ctx.getOptimizedOrderImage(_ctx.order.image3),
                  alt: "",
                  class: "order-card-images__item-img"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.officeName), 1),
          _createTextVNode(),
          (_ctx.evaluationTotalAverage)
            ? (_openBlock(), _createBlock(_component_EvaluationWithCount, {
                key: 0,
                value: _ctx.evaluationTotalAverage,
                count: _ctx.evaluationCount,
                "text-size": "12",
                size: "12"
              }, null, 8, ["value", "count"]))
            : _createCommentVNode("", true)
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_FeatherIcon, {
            icon: "map-pin",
            size: "14",
            class: "mr-1 text-mild"
          }),
          _createTextVNode(),
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.officeAddress), 1)
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.showOfficeFavoriteButton)
          ? (_openBlock(), _createBlock(_component_FavoriteButton, {
              key: 0,
              id: "tooltippopup-to-favorite-button",
              isFavorite: _ctx.isFavorite,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('favorite-change', $event)))
            }, null, 8, ["isFavorite"]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createVNode(_component_OfficeMuteButton, {
          isMuted: _ctx.isMutedOffice,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('change-muted-office', $event)))
        }, null, 8, ["isMuted"])
      ])
    ]),
    _createTextVNode(),
    _createVNode(_component_TooltipPopup, {
      position: "top",
      targetSelector: "#tooltippopup-to-favorite-button"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createTextVNode("\n        気に入った事業所は"),
          _createVNode(_component_TooltipHighlightText, null, {
            default: _withCtx(() => [
              _createTextVNode("お気に入り")
            ], undefined, true),
            _: 1
          }),
          _createTextVNode("に！\n      ")
        ])
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_22, [
      (_ctx.application)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_RemainingDateTime, {
                isApplied: true,
                isHiring: _ctx.order.isHiring
              }, null, 8, ["isHiring"]),
              _createTextVNode(),
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.appliedWorkTimeLabel), 1),
                _createTextVNode(),
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.appliedRestTimeLabel), 1)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.appliedSalaryPerDayWithVariousAllowances) + "円", 1),
                _createTextVNode(),
                (_ctx.hasAppliedNightWorkSalary(_ctx.application))
                  ? (_openBlock(), _createBlock(_component_Tag, {
                      key: 0,
                      label: "深夜手当",
                      class: "extra-wage-tag"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (_ctx.hasAppliedLegalOvertimeSalary(_ctx.application))
                  ? (_openBlock(), _createBlock(_component_Tag, {
                      key: 1,
                      label: "残業手当",
                      class: "extra-wage-tag"
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.workTimeOptions, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.id,
                class: _normalizeClass(["d-flex work-time-detail", { expired: !_ctx.isWorkTimeOptionAvailable(option) }]),
                role: "button",
                onClick: ($event: any) => (_ctx.onChangeSelectedWorkTimeOptionId(option))
              }, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_AppRadio, {
                    id: `work-time-option-${option.id}`,
                    name: "workTimeOption",
                    class: _normalizeClass(["work-time-option-radio", { invisible: !_ctx.isWorkTimeOptionAvailable(option) }]),
                    hasBorder: false,
                    value: option.id,
                    checked: option.id === _ctx.innerSelectedWorkTimeOptionId,
                    text: ""
                  }, null, 8, ["id", "value", "checked", "class"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", null, [
                  _createVNode(_component_RemainingDateTime, {
                    expiredAt: _ctx.getVisibleToDate(option),
                    isHiring: _ctx.order.isHiring
                  }, null, 8, ["expiredAt", "isHiring"]),
                  _createTextVNode(),
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.getOrderWorkTimeLabel(option)), 1),
                    _createTextVNode(),
                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.getOrderRestTimeLabel(option)), 1)
                  ]),
                  _createTextVNode(),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.getSalaryPerDayWithVariousAllowances(option)) + "円", 1),
                      _createTextVNode(),
                      (_ctx.hasNightWorkSalary(option))
                        ? (_openBlock(), _createBlock(_component_Tag, {
                            key: 0,
                            label: "深夜手当",
                            class: "extra-wage-tag"
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(),
                      (_ctx.hasLegalOvertimeSalary(option))
                        ? (_openBlock(), _createBlock(_component_Tag, {
                            key: 1,
                            label: "残業手当",
                            class: "extra-wage-tag"
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ], 10, _hoisted_30))
            }), 128))
          ])),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.hourlyWageLabel), 1),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.variousAllowancesLabel), 1)
      ])
    ], 512)
  ]))
}